import React, { useEffect } from 'react';

interface CompareCollapseProps {
  buttonContent: string | React.ReactNode;
  children?: React.ReactNode;
  isActive?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  id?: string | number;
}

export const CompareCollapse: React.FC<CompareCollapseProps> = ({
  buttonContent,
  children,
  isActive = false,
  onClick,
  id,
  ...otherProps
}) => {
  useEffect(() => {
    // Effect when isActive changes
  }, [isActive]);

  return (
    <>
      <tr className="mz-collapse mz-collapse-multi mzReactForms-component" id={'row_' + id}>
        <td>
          <button
            onClick={(e) => {
              if (onClick) {
                onClick(e);
              }
            }}
            className={`mz-collapse__button ${isActive ? 'active' : ''}`}
            {...otherProps}
          >
            {buttonContent}
            <i className={`mz-svg mz-svg-chevroncarousel mz-svg--grey${isActive ? 'visible' : ''}`}></i>
          </button>
        </td>
      </tr>
      {children}
    </>
  );
};

export default CompareCollapse;
